import RolesListUserManager from './RolesListUserManager'

export default RolesListUserManager
